import AchievementCard from './AchievementCard';

export default AchievementCard;
